import React from "react";
import UINode from "../UINode";

export default function ProductListLayout({ uinode }) {
  let { childNodes } = uinode;
  return childNodes.map((child, i) => <UINode key={i} node={child} />);
}
